import { Status, type AsyncState } from '@essent/common';
import { UtilApiActions } from '@innogy/feh/shared';
import type { GetAddressCheckResponse } from '@integration/api-client/util';
import { createReducer, on } from '@ngrx/store';

export const homebatteryAddressCheckSelectorKey = 'homebattery-address-check';

export type HomeBatteryAddressCheckState = AsyncState<GetAddressCheckResponse>;
export const initialHomebatteryAddressCheckState: HomeBatteryAddressCheckState =
  {
    status: Status.IDLE,
  };

export const homebatteryAddressCheckReducer =
  createReducer<HomeBatteryAddressCheckState>(
    initialHomebatteryAddressCheckState,
    on(UtilApiActions.getAddressCheck.successAction, (_, params) => ({
      status: Status.SUCCESS,
      data: params.payload,
    })),
    on(UtilApiActions.getAddressCheck.requestAction, (_) => ({
      status: Status.PENDING,
    })),
    on(UtilApiActions.getAddressCheck.errorAction, (_, params) => ({
      status: Status.ERROR,
      error: params.payload,
    }))
  );
